import { ROLES } from '../config/roles'

// The SimbaLink Chat desktop launcher (WebView2) appends "SimbaLinkChatViewer/<version>" to its user agent.
// In that app every role only gets the Chat page (same layout a Guest gets in a normal browser).
export const IS_LAUNCHER =
  typeof navigator !== 'undefined' && /SimbaLinkChatViewer\//.test(navigator.userAgent || '')

// True when the user may only use the Chat page: running inside the launcher, or a Guest account
export const isChatOnly = (roles) => IS_LAUNCHER || [].concat(roles ?? []).includes(ROLES.Guest)

// Branding of the public pages (Home / Login / Signup): the desktop launcher shows the chat app
export const BRAND = IS_LAUNCHER
  ? {
      name: 'SimbaLinkChat',
      icon: '/assets/simbachaticon.png',
      eyebrow: 'Secure team messaging',
      tagline: 'Chat, share files and call your team in one place.',
      backgrounds: [
        '/assets/background_chat.png',
        '/assets/backgrounds/chat-conversation.svg',
        '/assets/backgrounds/chat-network.svg',
        '/assets/backgrounds/chat-calls.svg',
      ],
    }
  : {
      name: 'SIMBALINK',
      icon: '/assets/simbalinkicon.png',
      eyebrow: 'Flight management platform',
      tagline: 'Manage flight operations, users, and units in one place.',
      backgrounds: [
        '/assets/background.jpg',
        '/assets/backgrounds/radar-scope.svg',
        '/assets/backgrounds/airfield-night.svg',
        '/assets/backgrounds/flight-network.svg',
      ],
    }

// Browser / window title and tab icon
if (IS_LAUNCHER && typeof document !== 'undefined') {
  document.title = BRAND.name
  document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((l) => { l.href = BRAND.icon })
}
